module.exports = __webpack_public_path__ + "img/10.44db4b0c.jpg";